import React from "react";

export default function MortgageStatementView({ data }) {
  if (!data) return null;

  return (
    <>
      <br />

      {/* Header */}
      <div className="w-full text-left p-3 flex items-center gap-3 bg-[#5a6db3] ">
        <h2 className="text-lg font-semibold">
          Mortgage Statement Details
        </h2>
      </div>

      {/* Mortgage + Statement Info */}
      <div className="border border-t-0 rounded-b-lg p-4 grid grid-cols-2 gap-6 bg-white shadow">
        {/* Mortgage Information */}
        <div>
          <h3 className="font-semibold mb-2">Mortgage Information</h3>
          <p><b>Lender Name:</b> {data.lender_name || "N/A"}</p>
          <p><b>Borrower Name:</b> {data.borrower_name || "N/A"}</p>
          <p><b>Mortgage Account No:</b> {data.mortgage_account_number || "N/A"}</p>
          <p><b>Property Address:</b> {data.property_address || "N/A"}</p>
          <p><b>Borrower Address:</b> {data.borrower_address || "N/A"}</p>
        </div>

        {/* Statement Information */}
        <div>
          <h3 className="font-semibold mb-2">Statement Information</h3>
          <p>
            <b>Statement Period:</b>{" "}
            {data.statement_start_date || "-"} -{" "}
            {data.statement_end_date || "-"}
          </p>
          <p>
            <b>Opening Balance:</b>{" "}
            {data.currency} {data.opening_balance || "0"}
          </p>
          <p>
            <b>Closing Balance:</b>{" "}
            {data.currency} {data.closing_balance || "0"}
          </p>
          <p>
            <b>Current Outstanding:</b>{" "}
            {data.currency} {data.current_outstanding_balance || "0"}
          </p>
          <p>
            <b>Interest Rate:</b>{" "}
            {data.interest_rate ?? "0"}%
          </p>
          <p>
            <b>Monthly Payment:</b>{" "}
            {data.currency} {data.monthly_payment_amount || "0"}
          </p>
        </div>
      </div>

      {/* Irregularities */}
      <div
        className="mt-4 p-3 border rounded-lg text-black"
        style={{ background: "aliceblue" }}
      >
        <b>Irregularities:</b>{" "}
        {data.has_irregular_transactions
          ? data.irregular_transaction_notes || "Yes"
          : "None"}
      </div>

      {/* Transactions */}
      <div className="border bg-white shadow mt-6">
        <h3 className="w-full text-left p-3 bg-[#5a6db3] ">
          Transactions
        </h3>

        <div className="overflow-x-auto">
          <table className="w-full border rounded-lg overflow-hidden">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-4 py-2 border">Date</th>
                <th className="px-4 py-2 border">Description</th>
                <th className="px-4 py-2 border text-right">Payments In</th>
                <th className="px-4 py-2 border text-right">Payments Out</th>
                <th className="px-4 py-2 border text-right">Balance</th>
              </tr>
            </thead>

            <tbody>
              {Array.isArray(data.transactions) && data.transactions.length ? (
                data.transactions.map((txn) => (
                  <tr key={txn.id} className="hover:bg-gray-50">
                    <td className="px-4 py-2 border">{txn.date}</td>
                    <td className="px-4 py-2 border">{txn.description}</td>

                    <td
                      className={`px-4 py-2 text-right border ${
                        txn.payments_in_amount
                          ? "text-green-600"
                          : "text-gray-400"
                      }`}
                    >
                      {txn.payments_in_amount || ""}
                    </td>

                    <td
                      className={`px-4 py-2 text-right border ${
                        txn.payments_out_amount
                          ? "text-red-600"
                          : "text-gray-400"
                      }`}
                    >
                      {txn.payments_out_amount || ""}
                    </td>

                    <td className="px-4 py-2 text-right border font-semibold">
                      {txn.balance}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center py-3 border">
                    No transactions found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
